// avoiding spam in error toasts
class ToastController {
  private status?: string
  constructor() {}
  handleSetToast(callback) {
    if (this.status === 'inProgress') return null
    this.status = 'inProgress'
    setTimeout(() => {
      this.status = 'pending'
    }, 5000)
    return callback()
  }
}
export default ToastController
